const state = {
  list: []
}

const getters = {
  GameList: state => state.list
}

const mutations = {
  save_GameList (state, data) {
    state.list = data;
  }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/games.js